module.exports = __webpack_public_path__ + "media/images/icon__betPick--pick-360a61465f566b2d8f46dae821ba1686.png";